import React from "react";

const shimmerKeyframes = `
  @keyframes shimmer {
    0%   { background-position: -300px 0; }
    100% { background-position: calc(300px + 100%) 0; }
  }
`;

const shimmer = {
  background: "linear-gradient(90deg, #e2e5ea 25%, #cdd1d8 50%, #e2e5ea 75%)",
  backgroundSize: "300px 100%",
  animation: "shimmer 1.5s infinite",
  borderRadius: "6px",
};

const pill = { ...shimmer, borderRadius: "20px" };

const CardSkeleton = () => (
  <>
    <style>{shimmerKeyframes}</style>

    {/* ── Top colour bar ── */}
    <div style={{ height: "4px", borderRadius: 0, ...shimmer }} />

    {/* ── Platform pill + count pill ── */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 20px 0",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
          style={{
            width: "26px",
            height: "26px",
            borderRadius: "50%",
            ...shimmer,
          }}
        />
        <div style={{ width: "64px", height: "14px", ...pill }} />
      </div>
      <div style={{ width: "72px", height: "26px", ...pill }} />
    </div>

    {/* ── Body ── */}
    <div style={{ padding: "14px 20px 0" }}>
      {/* Session ID */}
      <div
        style={{
          width: "140px",
          height: "13px",
          marginBottom: "14px",
          ...shimmer,
        }}
      />

      {/* Keyword block */}
      <div
        style={{
          background: "rgba(0,0,0,0.04)",
          border: "1px solid rgba(0,0,0,0.06)",
          borderRadius: "14px",
          padding: "11px 14px",
          marginBottom: "14px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "3px",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            ...shimmer,
            borderRadius: 0,
          }}
        />
        <div
          style={{
            width: "52px",
            height: "9px",
            marginBottom: "6px",
            marginLeft: "8px",
            ...shimmer,
          }}
        />
        <div
          style={{
            width: "80%",
            height: "15px",
            marginLeft: "8px",
            ...shimmer,
          }}
        />
      </div>

      {/* Meta grid — 2 cols + 1 wide */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px",
          marginBottom: "14px",
        }}
      >
        {/* Date */}
        <div
          style={{
            background: "rgba(0,0,0,0.03)",
            border: "1px solid rgba(0,0,0,0.05)",
            borderRadius: "11px",
            padding: "9px 11px",
          }}
        >
          <div
            style={{
              width: "44px",
              height: "8px",
              marginBottom: "5px",
              ...shimmer,
            }}
          />
          <div style={{ width: "70px", height: "12px", ...shimmer }} />
        </div>
        {/* Time Taken */}
        <div
          style={{
            background: "rgba(0,0,0,0.03)",
            border: "1px solid rgba(0,0,0,0.05)",
            borderRadius: "11px",
            padding: "9px 11px",
          }}
        >
          <div
            style={{
              width: "52px",
              height: "8px",
              marginBottom: "5px",
              ...shimmer,
            }}
          />
          <div style={{ width: "60px", height: "12px", ...shimmer }} />
        </div>
        {/* Objective — full width */}
        <div
          style={{
            gridColumn: "1 / -1",
            background: "rgba(0,0,0,0.03)",
            border: "1px solid rgba(0,0,0,0.05)",
            borderRadius: "11px",
            padding: "9px 11px",
          }}
        >
          <div
            style={{
              width: "52px",
              height: "8px",
              marginBottom: "5px",
              ...shimmer,
            }}
          />
          <div style={{ width: "110px", height: "12px", ...shimmer }} />
        </div>
      </div>

      {/* Status row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "14px",
          padding: "10px 14px",
          background: "rgba(0,0,0,0.03)",
          borderRadius: "12px",
          border: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <div style={{ width: "44px", height: "9px", ...shimmer }} />
        <div style={{ width: "72px", height: "26px", ...pill }} />
      </div>
    </div>
    {/* end body */}

    {/* ── Buttons ── */}
    <div
      style={{
        padding: "0 20px 20px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {/* Row 1 */}
      <div style={{ display: "flex", gap: "8px" }}>
        <div style={{ flex: 1, height: "38px", ...pill }} />
        <div style={{ flex: 1, height: "38px", ...pill }} />
      </div>
      {/* Row 2 */}
      <div style={{ display: "flex", gap: "8px" }}>
        <div style={{ flex: 1, height: "38px", ...pill }} />
      </div>
    </div>
  </>
);

export default CardSkeleton;
